import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import * as FormActions from '../../../reducers/actions/forms.actions';
import { MatDialog, MatSnackBar } from "@angular/material";
import { PerfilComponent } from "../../perfil/perfil.component";
import { Form } from '../../../models/form.model';
import { GLOBAL } from "src/app/services/global";

interface AppState {
    form: Form;
}

@Component({
    selector: 'app-mantencion-ascensores',
    templateUrl: './mantencion-ascensores.component.html',
    styleUrls: ['./mantencion-ascensores.component.css'],
    providers: []
})



export class MantencionAscensoresComponent implements OnInit {
    constructor(
        private store: Store<AppState>,
        private snackBar: MatSnackBar,
        private dialog: MatDialog
    ) {

    }

    identity;
    token;
    public footer = GLOBAL.footer;
    public web = GLOBAL.web;
    public webUrl = GLOBAL.webUrl;

    ngOnInit(): void {

    }


    logout() {
        this.store.dispatch(new FormActions.FormUpdate('0', ''))
        sessionStorage.removeItem("identity-domCloud");
        sessionStorage.removeItem("token-domCloud");
        this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
            duration: 3000,
        });
    }

    openPerfil() {
        this.dialog.open(PerfilComponent)
    }

}